var Pages = $.extend(false, BaseModule ,{

    api_route : 'pages',

    data : {
		module		    : 'pages',
		page		    : 1,
		limit		    : 42,
        view            : 'grid',
        pagination      : true
	},


    

    save_order:function(){
        var module_name = this.data.module,
            module = this,
            selection = [];
        
        $('input[name="order_item_id[]"]').each(function(){
            selection.push($(this).val());
        });

        $.ajax({
            url : API + module.api_route + '/order',
            method:'POST',
            data:{ 
                show_in: $('#'+module_name+'-dialog-list  select[name="show_in"]').val(),
                order_item_id: selection 
            },
            success:function(data){
                $("#"+module_name+"-dialog-list").modal('hide');
            }
        });
        return false;
    },

    commit : function(){
        var module_name = this.data.module,
        all_component_data = [],
        $form = $('form[name="'+module_name+'_form"]');

        $form.find('.content-editable').each(function(){
        var name = $(this).data('name').split('.'),

            component_data = $(this).closest('.article-component').data('component');

        if( typeof(component_data.data) == 'undefined' || component_data.data.length  ==0  ){
            component_data.data = {};
        }
        component_data.data[ String(name[0]) ] = $(this).html();
        if(component_data.data[ String(name[0]) ] == ''){
            component_data.data[ String(name[0]) ] = $(this).val();
        }
        $(this).closest('.article-component').data('component' , component_data);

    });


    $form.find('.article-component').each(function(){
        var component = $(this);

        if(component.data('component')){
            component_data =  $(this).data('component');

            if(component.data('key')){
                component_data['data'] = {};
                component_data['data']['images'] = [];
                component.find('input[name="' + component.data('key')+'"]').each(function(){
                    var vv = $(this).val();
                    component_data['data']['images'].push(vv);
                });
            }
            all_component_data.push(component_data);
        }

    });

    $form.find('input[name="components"]').val(JSON.stringify(all_component_data));
},

    before_save:function(){
        var module_name = this.data.module;
        Builder.set_target($('form[name="'+module_name+'_form"]')).commit();
    },

    after_load_entry:function(){

        "use strict";

        this.save();

        var module_name = this.data.module,
            module = this,
            $form = $('form[name="'+module_name+'_form"]');
        
        Builder.set_target($('form[name="'+module_name+'_form"]')).setup();


    },

	init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
	Pages.init();
});
